import { Component } from '@angular/core';

@Component({
  selector: 'facebook-pixel',
  templateUrl: './facebook-pixel.component.html'
})
export class FacebookPixelComponent {}
